(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
const normalizeTireValue = (value) => String(value || '').trim().toUpperCase().replace(/\s+/g, '');
function tireMatches(reference, candidate) {
  return Boolean(candidate && candidate.productId !== reference.productId && normalizeTireValue(reference.tireDimension) && normalizeTireValue(reference.tireDimension) === normalizeTireValue(candidate.tireDimension));
}

class TireSimilarProducts extends HTMLElement {
  connectedCallback() {
    if (this.started) return;
    this.started = true;
    this.controller = new AbortController();
    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        this.observer.disconnect();
        this.loadMatches();
      }
    }, { rootMargin: '600px' });
    this.observer.observe(this);
  }
  disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); }
  async readPage(url) {
    const response = await fetch(url, { signal: this.controller.signal });
    if (!response.ok) throw new Error('Unable to load tyre recommendations');
    return new DOMParser().parseFromString(await response.text(), 'text/html');
  }
  async loadFallback(limit, productId) {
    const url = new URL(this.dataset.fallbackUrl, window.location.origin);
    url.searchParams.set('product_id', productId);
    url.searchParams.set('section_id', this.dataset.sectionId);
    url.searchParams.set('limit', String(Math.min(limit, 10)));
    url.searchParams.set('intent', 'related');
    const page = await this.readPage(url);
    const seen = new Set([productId]);
    return [...page.querySelectorAll('product-card[data-product-id]')].filter((card) => {
      const id = card.dataset.productId;
      if (!id || seen.has(id)) return false;
      seen.add(id);
      return true;
    }).slice(0, limit);
  }
  async loadCatalogue(limit, productId) {
    const url = new URL(this.dataset.collectionUrl, window.location.origin);
    url.searchParams.set('sort_by', 'best-selling');
    const selected = [];
    const seen = new Set([productId]);
    let pageNumber = 1;
    while (selected.length < limit) {
      url.searchParams.set('page', String(pageNumber));
      const page = await this.readPage(url);
      const cards = [...page.querySelectorAll('main product-card[data-tire-dimension]')];
      let newCards = 0;
      for (const card of cards) {
        const id = card.dataset.productId;
        if (!id || seen.has(id)) continue;
        seen.add(id); newCards++;
        if (card.dataset.tireDimension) selected.push(card);
        if (selected.length === limit) break;
      }
      if (!newCards || !cards.length) break;
      pageNumber++;
    }
    return selected;
  }
  async loadMatches() {
    const reference = { ...this.dataset };
    const limit = Math.min(Number(reference.limit) || 4, 16);
    const grid = this.querySelector('[data-similar-grid]');
    const content = this.querySelector('[data-similar-content]');
    if (!grid || !content || !reference.productId) { this.dataset.state = 'empty'; return; }
    let selected = [];
    this.dataset.source = 'dimension';
    if (reference.tireDimension) {
      const url = new URL(reference.collectionUrl, window.location.origin);
      url.searchParams.set('filter.p.m.anvelope.dimension', reference.tireDimension);
      url.searchParams.set('sort_by', 'price-ascending');
      const seen = new Set();
      try {
        let pageNumber = 1;
        while (selected.length < limit) {
          url.searchParams.set('page', String(pageNumber));
          const page = await this.readPage(url);
          const cards = [...page.querySelectorAll('main product-card[data-tire-dimension]')];
          let newCards = 0;
          for (const card of cards) {
            const id = card.dataset.productId;
            if (!id || seen.has(id)) continue;
            seen.add(id); newCards++;
            if (tireMatches(reference, card.dataset)) selected.push(card);
            if (selected.length === limit) break;
          }
          if (!newCards || !cards.length) break;
          pageNumber++;
        }
      } catch (error) { if (error.name === 'AbortError') return; }
    }
    try {
      if (!selected.length) {
        this.dataset.source = 'shopify';
        try {
          selected = await this.loadFallback(limit, reference.productId);
        } catch (error) { if (error.name === 'AbortError') return; }
      }
      if (!selected.length) {
        this.dataset.source = 'catalogue';
        selected = await this.loadCatalogue(limit, reference.productId);
      }
      if (!this.isConnected || !selected.length) { this.dataset.state = 'empty'; return; }
      const fragment = document.createDocumentFragment();
      for (const card of selected) {
        const item = document.createElement('div');
        item.className = 'resource-list__item';
        item.append(document.importNode(card, true));
        fragment.append(item);
      }
      grid.replaceChildren(fragment);
      content.hidden = false;
      this.dataset.state = 'ready';
    } catch (error) { if (error.name !== 'AbortError') this.dataset.state = 'empty'; }
  }
}
if (!customElements.get('tire-similar-products')) customElements.define('tire-similar-products', TireSimilarProducts);


  } catch(e) { console.error(e); }
})();
})();
